<div class="content-heading">
    <div class="header-container">
        <h3>Reportes de Compulsas</h3>
        <small>Datos generados en las compulsas de EV y PT</small>
    </div>
</div>
<div class="container-fluid">
    <div class="card card-default">
        <div class="card-body">
            <div class="row">
                <div class="card-header">
                    <h3>Reporte de Compulsas EV</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <label class="form-label">Nodo</label>
                        <ceq-unit-autocomplete [listType]="'NODES'"
                                               [loading]="downloading"
                                               [unitOrgId]="0"
                                               (onUnitClear)="unitCleared()"
                                               (onUnitSelected)="selectedUnitChange($event)"></ceq-unit-autocomplete>
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <label class="form-label">Desde</label>
                        <input type="date" class="form-control" [max]="today" [ngModel]="minDate | date:'yyyy-MM-dd'" (ngModelChange)="minDate=$event" [disabled]="downloading">
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <label class="form-label">Hasta</label>
                        <input type="date" class="form-control" [max]="today" [ngModel]="maxDate | date:'yyyy-MM-dd'" (ngModelChange)="maxDate=$event" [disabled]="downloading">
                    </div>
                </div>
            </div>
            <div class="row col">
                <div class="row mt-3 col-lg-12 col-md-12">
                    <button class="mr-1 btn btn-labeled btn-outline-success mb-2" (click)="download()" *ngIf="!downloading">
                        <span class="btn-label">
                            <i class="fa fa-file-excel" aria-hidden="true" style="font-size: 1.5em;"></i>
                        </span>
                        <span>Descargar reporte</span>
                    </button>
                    <button class="mr-1 btn btn-labeled btn-outline-success mb-2" *ngIf="downloading" disabled>
                        <span class="btn-label">
                            <i class="fa fa-circle-notch fa-spin" style="font-size: 1.5em;"></i>
                        </span>
                        <span>Descargando</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-cut-pt-report class="noprint"></app-cut-pt-report>
